import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@app/core/config';
import { Observable } from 'rxjs';
import { HelpDeskContentType } from '../types/help-desk-content-type';

@Injectable({
	providedIn: 'root'
})
export class HelpDeskService {
constructor(
	@Inject(APP_CONFIG) private appConfig: IAppConfig,
	private http: HttpClient
) {
}

getHelpContent(helpDeskContentType: HelpDeskContentType): Observable<any> {
	const url = `${this.appConfig.apiEndpoint}/v2/HelpDesk/${helpDeskContentType}`;
	return this.http.get<any>(url);
}
}
